export default {
  methods: {
    async preview(pageSlug, domainId, version) {
      let { data } = await this.$admin.dataProvider.getOne("domains", {
        id: domainId,
      });

      const queryParams = {
        domain: data.url,
        slug: pageSlug,
      };

      if (version) {
        queryParams.version = version;
      }

      const previewRoute = this.$router.resolve({
        path: `/preview`,
        query: {
          ...queryParams,
        },
      });
      window.open(previewRoute.href, "_blank");
    },
  },
};
